import { render, staticRenderFns } from "./RedPillGo.vue?vue&type=template&id=06f566b0"
import script from "./RedPillGo.vue?vue&type=script&lang=js"
export * from "./RedPillGo.vue?vue&type=script&lang=js"
import style0 from "./RedPillGo.vue?vue&type=style&index=0&id=06f566b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports